<template>
  <div class="run-left-main">
    <vue-draggable
      v-model="stops"
      tag="ul"
      class="list-data list-data-run-list no-links no-hover has-drag has-button-right m-t-none"
      handle=".btn-drag"
      draggable=".draggable"
      filter=".disabled"
    >
      <template v-slot:header>
        <li class="data-heading sticky">
          <div class="row">
            <div class="col-xs-1">&nbsp;</div>
            <div class="col-xs-5">Station</div>
            <div class="col-xs-2">
              <p class="text-truncate">Pickup</p>
            </div>
            <div class="col-xs-2">
              <p class="text-truncate">Delivery</p>
            </div>
            <div class="col-xs-4"></div>
          </div>
          <!-- /.row -->
        </li>
      </template>

      <run-sheet-stops-item
        v-for="stop in deliveryRun.stops"
        :key="stop.id"
        :stop="stop"
        @deleted="deliveryRunStopDeleted"
        @addConsignmentNote="handleAddConsignmentNote"
      />
    </vue-draggable>
    <!-- /.list-data -->
    <add-consignment-note-to-stop-modal :runStop="runStop" />
  </div>
</template>

<script>
import { get, sync, call } from 'vuex-pathify'
import VueDraggable from 'vuedraggable'
import RunSheetStopsItem from './RunSheetStopsItem'
import AddConsignmentNoteToStopModal from './AddConsignmentNoteToStopModal'

export default {
  components: {
    VueDraggable,
    RunSheetStopsItem,
    AddConsignmentNoteToStopModal
  },

  data () {
    return {
      preventUpdatingStopOrder: false,
      runStop: {}
    }
  },

  computed: {
    ...get('deliveryRuns', ['deliveryRun']),
    deliveryRunStops: sync('deliveryRuns/deliveryRun@stops'),
    triggerUpdateDeliveryRunStopOrder: sync('deliveryRuns/triggers@updateDeliveryRunStopOrder'),
    triggerUpdateMapDirections: sync('deliveryRuns/triggers@updateMapDirections'),

    stops: {
      get () {
        return this.deliveryRun.stops
      },

      set (stops) {
        this.deliveryRunStops = stops.map((stop, index) => {
          return Object.assign(stop, { order: ++index })
        })

        this.triggerUpdateDeliveryRunStopOrder = true
        this.triggerUpdateMapDirections = true
      }
    }
  },

  watch: {
    triggerUpdateDeliveryRunStopOrder: {
      async handler () {
        if (this.triggerUpdateDeliveryRunStopOrder === false) {
          return
        }

        this.triggerUpdateDeliveryRunStopOrder = false

        await this.updateDeliveryRunStopOrder({
          id: this.deliveryRun.id,
          stops: this.deliveryRun.stops.map(({ id, order }) => ({ id, order }))
        })
      }
    }
  },

  methods: {
    ...call('deliveryRuns', ['updateDeliveryRunStopOrder']),

    deliveryRunStopDeleted (newDeliveryRunStops) {
      this.deliveryRunStops = newDeliveryRunStops

      this.triggerUpdateMapDirections = true
    },

    handleAddConsignmentNote (runStop) {
      this.runStop = runStop
    }
  }
}
</script>
